<template>
  <vs-popup
    class="popup overflow-hidden"
    button-close-hidden
    :active.sync="popUpShown"
    @close="closePopup"
  >
    <img
      class="vs-popup--close-button"
      :src="require('@/assets/shipo-popup-icon-close.svg')"
      @click="closePopup"
    >
    <div class="w-full text-xl font-semibold mb-4">
      Evidence
    </div>
    <div
      v-if="evidences && evidences.length"
      class="evidence-viewer-content"
    >
      <div class="main-image-container">
        <img
          v-if="currentImage"
          :src="currentImage.download_url || currentImage.dataUrl"
          alt="Evidence"
          class="main-image"
        >
        <div
          v-if="evidences.length > 1"
          class="nav-arrow nav-arrow-left"
          @click="previousImage"
        >
          <img :src="require('@/assets/shipo-icon-arrow-left.svg')">
        </div>
        <div
          v-if="evidences.length > 1"
          class="nav-arrow nav-arrow-right"
          @click="nextImage"
        >
          <img 
            :src="require('@/assets/shipo-icon-arrow-left.svg')"
          >
        </div>
      </div>
      <div
        v-if="evidences.length > 1"
        class="thumbnail-strip"
      >
        <div
          v-for="(evidence, index) in evidences"
          :key="index"
          :class="['thumbnail-container', { active: currentIndex === index }]"
          @click="selectImage(index)"
        >
          <img
            :src="evidence.download_url || evidence.dataUrl"
            alt="Thumbnail"
            class="thumbnail-image"
          >
        </div>
      </div>
    </div>
    <div
      v-else
      class="no-evidence text-center py-8"
    >
      <p class="text-gray-500">
        No evidence available
      </p>
    </div>
  </vs-popup>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      required: true
    },
    evidences: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      popUpShown: this.active,
      currentIndex: 0
    }
  },
  computed: {
    currentImage() {
      if (this.evidences && this.evidences.length && this.currentIndex < this.evidences.length) {
        return this.evidences[this.currentIndex]
      }
      return null
    }
  },
  watch: {
    active: {
      handler(val) {
        this.popUpShown = val
        if (val) {
          this.currentIndex = 0
        }
      }
    },
    evidences: {
      handler() {
        this.currentIndex = 0
      }
    }
  },
  methods: {
    nextImage() {
      if (this.currentIndex < this.evidences.length - 1) {
        this.currentIndex++
      } else {
        this.currentIndex = 0
      }
    },
    previousImage() {
      if (this.currentIndex) {
        this.currentIndex--
      } else {
        this.currentIndex = this.evidences.length - 1
      }
    },
    selectImage(index) {
      this.currentIndex = index
    },
    closePopup() {
      this.$emit('update:active', false)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.popup {
  /deep/.vs-popup {
    @apply w-3/4;
    @apply rounded-2xl;
    max-width: 900px;

    &--title {
      @apply hidden;
    }

    &--content {
      @apply p-8;
      @apply relative;
      @apply m-0;
      @apply flex;
      @apply flex-col;
      @apply h-full;
      @apply w-full;
      max-height: 90vh;
      overflow-y: auto;
      overflow-x: hidden;
    }

    &--close-button {
      @apply cursor-pointer;
      @apply absolute;
      width: 30px;
      top: 1rem;
      right: 1rem;
      z-index: 10;
    }
  }
}

.evidence-viewer-content {
  @apply flex;
  @apply flex-col;
  @apply w-full;
}

.main-image-container {
  @apply relative;
  @apply w-full;
  @apply mb-4;
  @apply bg-gray-100;
  @apply rounded-lg;
  @apply overflow-hidden;
  min-height: 400px;
  max-height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main-image {
  @apply w-full;
  @apply h-full;
  object-fit: contain;
  max-height: 600px;
}

.nav-arrow {
  @apply absolute;
  @apply cursor-pointer;
  @apply bg-white;
  @apply rounded-full;
  @apply p-2;
  @apply shadow-lg;
  top: 50%;
  transform: translateY(-50%);
  z-index: 5;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }

  img {
    width: 24px;
    height: 24px;
  }
}

.nav-arrow-left {
  left: 1rem;
}

.nav-arrow-right {
  right: 1rem;
  transform: rotate(180deg);
}

.thumbnail-strip {
  @apply flex;
  @apply gap-2;
  @apply justify-center;
  @apply overflow-x-auto;
  @apply pb-2;
  padding: 0.5rem;
}

.thumbnail-container {
  @apply cursor-pointer;
  @apply border-2;
  @apply border-transparent;
  @apply rounded-lg;
  @apply overflow-hidden;
  @apply transition-all;
  min-width: 100px;
  width: 100px;
  height: 100px;
  flex-shrink: 0;

  &:hover {
    @apply border-primary;
    opacity: 0.8;
  }

  &.active {
    @apply border-primary;
    border-width: 3px;
  }
}

.thumbnail-image {
  @apply w-full;
  @apply h-full;
  object-fit: cover;
}

.no-evidence {
  @apply text-gray-500;
  @apply py-8;
}

@media (max-width: 767px) {
  .popup {
    /deep/.vs-popup {
      @apply w-full;
      max-width: 100%;
    }
  }

  .main-image-container {
    min-height: 300px;
    max-height: 400px;
  }

  .nav-arrow {
    padding: 0.5rem;

    img {
      width: 20px;
      height: 20px;
    }
  }

  .thumbnail-container {
    min-width: 80px;
    width: 80px;
    height: 80px;
  }
}
</style>

